<template>
  <div>
    <QS-forbidden />
  </div>
</template>

<script>

export default {
  name: 'Page403',
}
</script>

<style  lang="scss" scoped>

</style>
